export default __webpack_public_path__ + "static/media/aksons-logo-white.f829c0d0.svg";